import { useQuery } from "@tanstack/react-query";
import { rmResvDtlApi } from "components/api/room";
import i18n from "locales/i18n";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setMessage } from "store/commonSlice";
import { dateFormat, getDay, inCom } from "util/common";
import "./home.scss";

type Iprops = {
  rmPdNo: string;
};

const RmDtlInfoView = ({ rmPdNo }: Iprops) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const memType = pathname.includes("manager") ? "manager" : "admin";

  const query = useQuery({
    queryKey: ["rmResvDtl", memType],
    queryFn: () => {
      return rmResvDtlApi({ rmPdNo });
    },
    enabled: !!rmPdNo,
    onSuccess(data) {
      if (data) {
        const {
          header: { code, message },
          body,
        } = data;

        if (code === -1) {
          dispatch(setMessage({ message }));
        }
      }
    },
  });

  const rmResvDtl = query?.data?.body?.rmResvDtl || {};
  const resvPayDtl = query?.data?.body?.resvPayDtl || {};

  let manNm = rmResvDtl?.resvMemSurnm + rmResvDtl?.resvMemFstnm ?? "";

  return (
    <>
      <div className="main-cnt">
        <div className="mx-auto table-form ">
          <table>
            <tbody>
              {memType === "admin" && (
                <tr>
                  <th>숙소그룹명</th>
                  <td>
                    <input
                      type="text"
                      defaultValue={rmResvDtl?.lodGrpNm}
                      readOnly
                    />
                  </td>
                  <th>숙소명</th>
                  <td>
                    <input
                      type="text"
                      defaultValue={rmResvDtl?.lodNm ?? ""}
                      readOnly
                    />
                  </td>
                </tr>
              )}
              <tr>
                <th>객실명</th>
                <td>
                  <input
                    type="text"
                    defaultValue={rmResvDtl?.rmNm ?? ""}
                    readOnly
                  />
                </td>
              </tr>
              <tr>
                <th>객실타입</th>
                <td>
                  <input
                    type="text"
                    defaultValue={rmResvDtl?.rmTypNm ?? ""}
                    readOnly
                  />
                </td>
                <th>객실전망</th>
                <td>
                  <input
                    type="text"
                    defaultValue={rmResvDtl?.rmOlkNm ?? ""}
                    readOnly
                  />
                </td>
              </tr>
              <tr>
                <th>객실상품번호</th>
                <td>
                  <input
                    type="text"
                    defaultValue={rmResvDtl?.rmPdNo ?? ""}
                    readOnly
                  />
                </td>
                <th>객실상품채널</th>
                <td>
                  <input
                    type="text"
                    defaultValue={rmResvDtl?.lodChlNm ?? ""}
                    readOnly
                  />
                </td>
              </tr>
              {/* <tr>
                <th>객실상품명</th>
                <td></td>
                <th>객실상품설명</th>
                <td></td>
              </tr> */}
              <tr>
                <th>객실상품 조식포함</th>
                <td>
                  <input
                    type="text"
                    defaultValue={
                      rmResvDtl?.brkfInYn === "Y" ? "포함" : "미포함"
                    }
                    readOnly
                  />
                </td>
                <th>객실상품 레이트 체크아웃시간</th>
                <td>
                  <input
                    type="text"
                    defaultValue={
                      rmResvDtl?.latChkOutTi?.replace(
                        /\B(?=(\d{2})+(?!\d))/g,
                        ":"
                      ) ?? ""
                    }
                    readOnly
                  />
                </td>
              </tr>
              <tr>
                <th>객실상품 특가할인</th>
                <td>
                  <input type="text" defaultValue={""} readOnly />
                </td>
              </tr>
              <tr>
                <th>객실상품 일자</th>
                <td>
                  <input
                    type="text"
                    defaultValue={dateFormat(rmResvDtl?.sellDt + "") ?? ""}
                    readOnly
                  />
                </td>
                <th>객실상품 요일 </th>
                <td>
                  <input
                    type="text"
                    defaultValue={getDay(rmResvDtl?.dowV + "", i18n.language)}
                    readOnly
                  />
                </td>
              </tr>
              <tr>
                <th>객실상품 금액</th>
                <td>
                  <input
                    type="text"
                    defaultValue={inCom(rmResvDtl?.sellPri ?? "")}
                    readOnly
                  />
                </td>
              </tr>
              <tr>
                <th>프로모션번호</th>
                <td>
                  <input type="text" defaultValue="" readOnly />
                </td>
                <th>프로모션명</th>
                <td>
                  <input type="text" readOnly />
                </td>
              </tr>
              <tr>
                <th>프로모션 금액 </th>
                <td>
                  <input type="text" readOnly />
                </td>
              </tr>
              <tr>
                <th>객실예약 번호</th>
                <td>
                  <input
                    type="text"
                    defaultValue={rmResvDtl?.rmResvNo ?? ""}
                    readOnly
                  />
                </td>
                <th>객실예약 순번번호</th>
                <td>
                  <input type="text" defaultValue={1} readOnly />
                </td>
              </tr>
              <tr>
                <th>객실예약 시작일자</th>
                <td>
                  <input
                    type="text"
                    defaultValue={rmResvDtl?.resvSDt ?? ""}
                    readOnly
                  />
                </td>
                <th>객실예약 종료일자</th>
                <td>
                  <input
                    type="text"
                    defaultValue={rmResvDtl?.resvEDt ?? ""}
                    readOnly
                  />
                </td>
              </tr>
              <tr>
                <th>객실예약 일수</th>
                <td>
                  <input
                    type="text"
                    defaultValue={rmResvDtl?.resvDayCt ?? ""}
                    readOnly
                  />
                </td>
                <th>객실예약 수량</th>
                <td>
                  <input
                    type="text"
                    defaultValue={rmResvDtl?.resvRmCt ?? ""}
                    readOnly
                  />
                </td>
              </tr>
              <tr>
                <th>객실예약 전체인원수</th>
                <td>
                  <input
                    type="text"
                    defaultValue={rmResvDtl?.resvPerCt ?? ""}
                    readOnly
                  />
                </td>
                <th>객실예약 성인인원수</th>
                <td>
                  <input
                    type="text"
                    defaultValue={rmResvDtl?.adltPerCt ?? ""}
                    readOnly
                  />
                </td>
              </tr>
              <tr>
                <th>객실예약 아동인원수</th>
                <td>
                  <input
                    type="text"
                    defaultValue={rmResvDtl?.chldPerCt ?? ""}
                    readOnly
                  />
                </td>
                <th>객실예약 무료인원수</th>
                <td>
                  <input
                    type="text"
                    defaultValue={rmResvDtl?.basPerCt ?? ""}
                    readOnly
                  />
                </td>
              </tr>

              <tr>
                <th>객실예약이메일 발송일시</th>
                <td>
                  <input type="text" defaultValue={""} readOnly />
                </td>
                <th>갤실예약팩스 발송일시</th>
                <td>
                  <input type="text" defaultValue={""} readOnly />
                </td>
              </tr>
              <tr>
                <th>객실예약 회원이름</th>
                <td>
                  <input type="text" defaultValue={""} readOnly />
                </td>
                <th>객실예약 회원전화번호</th>
                <td>
                  <input
                    type="text"
                    defaultValue={rmResvDtl?.resvMemMobNo ?? ""}
                    readOnly
                  />
                </td>
              </tr>
              <tr>
                <th>객실예약 고객이름</th>
                <td>
                  <input
                    type="text"
                    defaultValue={
                      rmResvDtl?.resvCstSurnm + rmResvDtl?.resvCstFstnm ?? ""
                    }
                    readOnly
                  />
                </td>
                <th>객실예약 고객전화번호</th>
                <td>
                  <input
                    type="text"
                    defaultValue={rmResvDtl?.resvCstMblNo ?? ""}
                    readOnly
                  />
                </td>
              </tr>
              <tr>
                <th>객실예약 고객이메일</th>
                <td>
                  <input
                    type="text"
                    defaultValue={rmResvDtl?.resvCstEml ?? ""}
                    readOnly
                  />
                </td>
              </tr>
              <tr>
                <th>정산금액</th>
                <td>
                  <input
                    type="text"
                    defaultValue={inCom(rmResvDtl?.resvSumAmt ?? "")}
                    readOnly
                  />
                </td>
              </tr>
              <tr>
                <th>객실예약 요청사항</th>
                <td colSpan={3}>
                  <textarea
                    name=""
                    id=""
                    defaultValue={rmResvDtl?.reqCm ?? ""}
                    readOnly
                  />
                </td>
              </tr>
              <tr>
                <th>객실예약 결제정보</th>
                <td colSpan={3}>
                  <fieldset disabled={true} className="pay-inf">
                    <div>
                      <span>결제일시</span>
                      <span>
                        {dateFormat(resvPayDtl?.tranDtti?.slice(0, 8))}{" "}
                        {resvPayDtl?.tranDtti?.slice(8, 10)}:
                        {resvPayDtl?.tranDtti?.slice(10, 12)}:
                        {resvPayDtl?.tranDtti?.slice(12, 14)}
                      </span>
                    </div>
                    <div>
                      <span>결제등록일련번호</span>
                      <span>{resvPayDtl?.payRgSeq ?? ""}</span>
                    </div>
                    <div>
                      <span>결제금액</span>
                      <span>{inCom(resvPayDtl?.payAmt ?? "") ?? ""}</span>
                    </div>
                    <div>
                      <span>통화코드</span>
                      <span>{resvPayDtl?.currCd ?? ""}</span>
                    </div>
                    <div>
                      <span>할부월</span>
                      <span>
                        {resvPayDtl?.instMont === "00"
                          ? "일시불"
                          : resvPayDtl?.instMont}
                        {resvPayDtl?.instMont ? "월" : ""}
                      </span>
                    </div>
                    <div>
                      <span>결제유형</span>
                      <span>{resvPayDtl?.cardCorp}</span>
                    </div>
                    <div>
                      <span>결제언어코드</span>
                      <span>{resvPayDtl?.payLangCd}</span>
                    </div>
                    <div>
                      <span>구매자이름</span>
                      <span>{resvPayDtl?.buyerNm}</span>
                    </div>
                    <div>
                      <span>구매자 이메일</span>
                      <span>{resvPayDtl?.buyerEml ?? ""}</span>
                    </div>
                    <div>
                      <span>결제방법</span>
                      <span>{resvPayDtl?.cardCorp ?? ""}</span>
                    </div>
                  </fieldset>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default RmDtlInfoView;
